import './_tag.scss'

import cn from '../../libs/class-names'

import {CommonProps, Overwrite} from '../../types'

type Props = Overwrite<
  CommonProps<'span'>,
  {
    children: string
    size?: 'default' | 'l'
  }
>

const Tag = ({className, children, size = 'default', ...props}: Props) => (
  <span {...props} className={cn('Tag', {[`size-${size}`]: !!size}, className)}>
    {children}
  </span>
)

export default Tag
